// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/authorization/v1/action_api.proto (package ai.h2o.authorization.v1, syntax proto3)
/* eslint-disable */

import type { Action } from "./action_pb";
import { RPC } from "../../../../runtime";

/**
 * @generated from message ai.h2o.authorization.v1.GetActionRequest
 */
export type GetActionRequest = {
/**
 * Action name, e.g. "actions/test-service/MY_ACTION".
 *
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.GetActionResponse
 */
export type GetActionResponse = {
/**
 * @generated from field: ai.h2o.authorization.v1.Action action = 1;
 */
action?: Action;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.CreateActionRequest
 */
export type CreateActionRequest = {
/**
 * @generated from field: ai.h2o.authorization.v1.Action action = 1;
 */
action?: Action;
/**
 * Required. ID or the name of the action.
 *
 * This should should be in the <service_name>/<action_name> format where
 * the action_name can be further nested with slashes. For example:
 * "my-service/collection/ACTION".
 *
 * @generated from field: string action_id = 2;
 */
actionId?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.CreateActionResponse
 */
export type CreateActionResponse = {
/**
 * @generated from field: ai.h2o.authorization.v1.Action action = 1;
 */
action?: Action;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.DeleteActionRequest
 */
export type DeleteActionRequest = {
/**
 * Action name, e.g. "actions/my-service/MY_ACTION".
 *
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.DeleteActionResponse
 */
export type DeleteActionResponse = {
}
;
/**
 * @generated from message ai.h2o.authorization.v1.ListActionsRequest
 */
export type ListActionsRequest = {
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 * Server can decide to return more or less items then specified.
 *
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
/**
 * When used, server will only return actions that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 * See https://github.com/h2oai/authz-server/blob/main/docs/adopting.md#filtering for specific supported
 * features.
 *
 * Supported fields:
 *   * name
 *   * display_name
 *   * description
 *
 * Fields that are used for literal string matching:
 *  * display_name
 *  * description
 *
 * @generated from field: string filter = 3;
 */
filter?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.ListActionsResponse
 */
export type ListActionsResponse = {
/**
 * @generated from field: repeated ai.h2o.authorization.v1.Action actions = 1;
 */
actions?: Action[];
/**
 * When not empty server has more results then returned. Use this value as
 * the page_token in the ListActionsRequest to obtain next page of results.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Returns details of the action specified by the name.
 *
 * Authorized by the "actions/policyserver/actions/READ" action on the
 * "//policyserver" resource.
 *
 * @generated from rpc ai.h2o.authorization.v1.ActionService.GetAction
 */
export const ActionService_GetAction = new RPC<GetActionRequest,GetActionResponse>("GET", "/v1/{name=actions/**}");
/**
 * Creates a new action.
 *
 * Authorized by the "actions/policyserver/actions/CREATE" action on the
 * "//policyserver" resource.
 *
 * Authorization can be bypassed when authorization bypass feature is enabled.
 *
 * @generated from rpc ai.h2o.authorization.v1.ActionService.CreateAction
 */
export const ActionService_CreateAction = new RPC<CreateActionRequest,CreateActionResponse>("POST", "/v1/actions", "action");
/**
 * Deletes the action specified by the name.
 *
 * Authorized by the "actions/policyserver/actions/DELETE" action on the
 * action to be deleted resource.
 *
 * @generated from rpc ai.h2o.authorization.v1.ActionService.DeleteAction
 */
export const ActionService_DeleteAction = new RPC<DeleteActionRequest,DeleteActionResponse>("DELETE", "/v1/{name=actions/**}");
/**
 * Lists all actions.
 *
 * Authorized by the "actions/policyserver/actions/READ" action on the
 * "//policyserver" resource.
 *
 * Authorization can be bypassed when authorization bypass feature is enabled.
 *
 * @generated from rpc ai.h2o.authorization.v1.ActionService.ListActions
 */
export const ActionService_ListActions = new RPC<ListActionsRequest,ListActionsResponse>("GET", "/v1/actions");
